var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedLicenseQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    height: 2048,
    width: 2048,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    style: {
      transform: "scale(1) translate(0px, 0px)"
    }
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,59.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,266.5)"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 19 19v 63h 63v -63zM 28 28h 45v 45h -45z",
    transform: "rotate(0,50.5,50.5)"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 27,
    height: 27,
    transform: "rotate(0,50.5,50.5)"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 217 19v 63h 63v -63zM 226 28h 45v 45h -45z",
    transform: "rotate(90,248.5,50.5)"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 37,
    width: 27,
    height: 27,
    transform: "rotate(90,248.5,50.5)"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 19 217v 63h 63v -63zM 28 226h 45v 45h -45z",
    transform: "rotate(-90,50.5,248.5)"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 235,
    width: 27,
    height: 27,
    transform: "rotate(-90,50.5,248.5)"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-background-color')",
    fill: "#ffffff",
    style: {
      transform: "scale(1) translate(0px, 0px)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000",
    style: {
      transform: "scale(1) translate(0px, 0px)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    height: 63,
    width: 63,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#000000",
    style: {
      transform: "scale(1) translate(0px, 0px)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    height: 27,
    width: 27,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#000000",
    style: {
      transform: "scale(1) translate(0px, 0px)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 19,
    height: 63,
    width: 63,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#000000",
    style: {
      transform: "scale(1) translate(0px, 0px)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 37,
    height: 27,
    width: 27,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#000000",
    style: {
      transform: "scale(1) translate(0px, 0px)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 217,
    height: 63,
    width: 63,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#000000",
    style: {
      transform: "scale(1) translate(0px, 0px)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 235,
    height: 27,
    width: 27,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#000000",
    style: {
      transform: "scale(1) translate(0px, 0px)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedLicenseQrcode);
export default __webpack_public_path__ + "static/media/verified_license_qrcode.23104aea197529405842f381bbd0bcf0.svg";
export { ForwardRef as ReactComponent };